import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { filter, withLatestFrom } from 'rxjs/operators';

import {
  CpDuplicateTags,
  DuplicateTagsFailure,
  DuplicateTagsSuccess,
  McpDuplicateTags,
  PackageCommonActionTypes,
  PCLoadFailure,
} from '@completion/actions';
import { HttpStatus } from '@completion/enums';
import { State } from '@completion/reducers';
import { getCurrentCpId, getCurrentMcpId, getCurrentProject } from '@completion/selectors';
import { CpService, McpService } from '@completion/services';
import { Project } from '@completion/models';
import { Observable } from 'rxjs';
import { trackResource } from './resource-fetch.util';

@Injectable()
export class PackageCommonEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly cpService: CpService,
    private readonly mcpService: McpService,
    private readonly store: Store<State>,
  ) {}

  cpDuplicateTags$ = createEffect(() => {
    return this.actions$.pipe(
      ofType<CpDuplicateTags>(PackageCommonActionTypes.CpDuplicateTags),
      withLatestFrom(this.store.select(getCurrentProject) as Observable<Project>, this.store.select(getCurrentCpId) as Observable<number>),
      filter(([_, currentProject, cpId]) => !!(currentProject && cpId)),
      trackResource({
        actions$: this.actions$,
        store: this.store,
        service: this.cpService,
        toastr: null as any,
        method: 'duplicateTags',
        serviceArgs: ([action, currentProject, cpId]) => [currentProject.id, cpId, action.checkSheetAssignment],
        onSuccess: (response: any) => new DuplicateTagsSuccess(response.status),
        onError: (response: HttpErrorResponse) => {
          switch (response.status) {
            case HttpStatus.BAD_REQUEST:
              return new DuplicateTagsFailure((response as any).error);
            default:
              return new PCLoadFailure(response.message as any);
          }
        },
      }),
    );
  });

  mcpDuplicateTags$ = createEffect(() =>
    this.actions$.pipe(
      ofType<McpDuplicateTags>(PackageCommonActionTypes.McpDuplicateTags),
      withLatestFrom(this.store.select(getCurrentProject) as Observable<Project>, this.store.select(getCurrentMcpId) as Observable<number>),
      filter(([_, currentProject, mcpId]) => !!(currentProject && mcpId)),
      trackResource({
        actions$: this.actions$,
        store: this.store,
        service: this.mcpService,
        toastr: null as any,
        method: 'duplicateTags',
        serviceArgs: ([action, currentProject, mcpId]) => [currentProject.id, mcpId, action.checkSheetAssignment],
        onSuccess: (response: any) => new DuplicateTagsSuccess(response.status),
        onError: (response: HttpErrorResponse) => {
          switch (response.status) {
            case HttpStatus.BAD_REQUEST:
              return new DuplicateTagsFailure((response as any).error);
            default:
              return new PCLoadFailure(response.message as any);
          }
        },
      }),
    ),
  );
}
